/*
 * Etapa que possui input de dados
 */
export const CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS = 'download-checklists';

/*
 * Etapa que possui input de dados
 */
export const CONTRATO_EDIT_ETAPA_DADOS = 'dados';

/*
 * Etapa onde apresenta o contrato ou possibilita upload/download do arquivo do contrato em edição.
 */
export const CONTRATO_EDIT_ETAPA_VALIDACAO = 'validacao';

/*
 * Etapa onde o perfil operacional valida o contrato/aditivo/distrato.
 */
export const CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL = 'analise-operacional';

/*
 * Etapa que mostra todos os arquivos relacionados a um contrato.
 */
export const CONTRATO_EDIT_ETAPA_ARQUIVOS = 'arquivos';

export const allContratoEditEtapas = [
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
];

export const allContratoAssessorEditEtapas = [
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
];

export const allContratoEntePublicoEditEtapas = [
  CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS,
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
];

export const allContratoEntePrivadoEditEtapas = [
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
];
